// extracted by mini-css-extract-plugin
export default {"root":"oK3vOGQvutqPHZFi47JE","active":"JPe2cCm8LM0bx0floIwj","placeHolderShimmer":"yq7HXCUTSSgflh2uqsGm"};